module.exports = __webpack_public_path__ + "img/vertical_7_7_5.c85b1f4c.png";